var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useEffect, useState } from "react";
var PublicRoomsPane = function (props) {
    var _a = useState([]), publicRooms = _a[0], setPublicRooms = _a[1];
    useEffect(function () {
        loadPublicRooms();
    }, []);
    var loadPublicRooms = function () {
        try {
            var fetchAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
                var fetchResult, resultJSON;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetch("public_games.json")];
                        case 1:
                            fetchResult = _a.sent();
                            return [4 /*yield*/, fetchResult.json()];
                        case 2:
                            resultJSON = _a.sent();
                            setPublicRooms(resultJSON);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchAsync().catch(function (e) {
                console.error(e);
            });
        }
        catch (err) {
            console.log(err);
        }
    };
    return (React.createElement("div", { className: "mt-6 border-t border-[var(--border-subtle)] pt-5" },
        React.createElement("div", { className: "mb-3 flex items-center justify-between gap-2" },
            React.createElement("div", null,
                React.createElement("h3", { className: "m-0 text-base font-bold tracking-tight text-[var(--text-primary)]" }, "Public rooms"),
                React.createElement("p", { className: "m-0 mt-0.5 text-xs text-[var(--text-secondary)]" }, "Open games anyone can join \u2014 find new friends to play with.")),
            React.createElement("button", { type: "button", onClick: loadPublicRooms, className: "sj-btn !min-h-[44px] !px-3 !py-1 !text-sm" }, "Refresh")),
        publicRooms.length === 0 ? (React.createElement("p", { className: "m-0 rounded-[var(--radius-xl)] border border-dashed border-[var(--border-strong)] px-3 py-4 text-center text-sm text-[var(--text-secondary)]" }, "No public rooms available right now.")) : (React.createElement("ul", { className: "m-0 flex list-none flex-col gap-2 p-0" }, publicRooms.map(function (roomInfo) { return (React.createElement("li", { key: roomInfo.name },
            React.createElement("button", { type: "button", onClick: function () { return props.setRoomName(roomInfo.name); }, className: "flex w-full items-center justify-between gap-3 rounded-[var(--radius-xl)] border border-[var(--border-subtle)] bg-[var(--surface-panel-soft)] px-3 py-2 text-left transition hover:border-[var(--accent)]" },
                React.createElement("span", { className: "font-mono text-sm font-semibold text-[var(--text-primary)]" }, roomInfo.name),
                React.createElement("span", { className: "sj-chip" },
                    roomInfo.num_players,
                    " players")))); })))));
};
export default PublicRoomsPane;
